import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClienteConsultaCreditoVoucher } from '../../../interfaces/cliente';
import { NgxSpinnerService } from 'ngx-spinner';
import { AngularFireDatabase } from '@angular/fire/database';
import { UsuarioService } from '../../../services/usuario.service';
import { take } from 'rxjs/operators';
import { PedidoConsultaElement } from '../../../interfaces/pedido.consulta';
import * as firebase from 'firebase';
import { CreditoVoucherHistorico } from '../../../interfaces/creditoVoucherHistorico';
import { Router } from '@angular/router';


@Component({
  selector: 'app-cancelar-pedido',
  templateUrl: './adicionar-credito-voucher-dialog.html',
  styleUrls: ['./adicionar-credito-voucher-dialog.scss', '../../../styles/estilo.padrao.scss']
})

export class AdicionarCreditoVoucherDialog implements OnInit {
  uid;
  creditoVoucherForm: FormGroup;
  cliente: ClienteConsultaCreditoVoucher;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<AdicionarCreditoVoucherDialog>,
    private spinner: NgxSpinnerService,
    private db: AngularFireDatabase,
    private usuarioService: UsuarioService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { cliente: ClienteConsultaCreditoVoucher }
  ) {
    this.uid = localStorage.getItem('uid');
    this.cliente = data.cliente;
  }

  ngOnInit(): void {
    this.creditoVoucherForm = this.formBuilder.group({
      pedidoReferencia: [null, [Validators.required, Validators.min(1)]],
      valorVoucher: [0, [Validators.required, Validators.min(0.01)]],
      descricao: ['', [Validators.required, Validators.minLength(20)]],
      cliente: [`${this.cliente.Nome} - ${this.cliente.CPFCNPJ} - ${this.cliente.Cidade}/${this.cliente.UF}`, null],
    });

    this.creditoVoucherForm.get('cliente').disable();
  }

  confirmarCreditoVoucher() {
    //Verificar se o pedido referenciado é do cliente
    if (this.creditoVoucherForm.valid) {
      this.spinner.show('default');

      this.usuarioService.getPedidoPorNumero(this.f.pedidoReferencia.value).pipe(take(1)).subscribe((snap: any) => {
        if (snap) {
          const pedido: PedidoConsultaElement = snap.payload.val() as PedidoConsultaElement;
          if (pedido?.IDUsuario === this.cliente.ID) {
            this.finalizarCreditoVoucher();
          } else {
            this.toastr.error(`O pedido informado não foi realizado pelo cliente ${this.cliente.Nome}.`, 'Erro');
            this.spinner.hide('default');
          }
        } else {
          this.toastr.error("Pedido não encontrado.", 'Erro');
          this.spinner.hide('default');
        }
      });

    } else {
      this.toastr.error("Preencha os campos corretamente!", 'Erro');
    }
  }

  finalizarCreditoVoucher() {

    this.db.object('Clientes/' + this.uid + '/CreditoVoucherClientes/' + this.cliente.ID + '/TotalVoucher').query.ref.transaction(valor => {
      //Se a tabela do cliente nmão existir, o dado será será criado diretamente. Se existir, será feita a soma de acordo com a transação.
      if (this.cliente.ExisteVoucherBD) {
        if (valor !== null) {
          valor = valor + this.f.valorVoucher.value;
        }
      } else {
        valor = this.f.valorVoucher.value;
      }

      return valor;
    }).then(resp => {
      const creditoVoucherHistorico: CreditoVoucherHistorico = {
        ValorVoucher: this.f.valorVoucher.value,
        Timestamp: firebase.default.database.ServerValue.TIMESTAMP,
        Descricao: this.f.descricao.value,
        PedidoReferencia: this.f.pedidoReferencia.value,
        Tipo: 'Credito'
      }
      if (resp.committed) {
        this.usuarioService.pushHistoricoCreditoVoucher(this.cliente.ID, creditoVoucherHistorico);
        this.usuarioService.setLog(`CreditoVoucher: ${this.f.valorVoucher.value} para o cliente: ${this.cliente.ID}`, creditoVoucherHistorico, this.uid);
        this.finalizar(true);
      } else {
        this.usuarioService.setLog(`Falha ao adicionar CreditoVoucher: ${this.f.valorVoucher.value} para o cliente: ${this.cliente.ID}`, creditoVoucherHistorico, this.uid);
        this.finalizar(false);
      }
    });
  }

  finalizar(b: boolean) {
    if (b)
      this.toastr.success("Crédito adicionado com sucesso!", 'Status');
    else
      this.toastr.error("Houve uma falha ao adicionar o crédito. Atualize a página e confira o saldo do cliente. Caso necessário, tente novamente.", 'Erro');

    setTimeout(() => {
      this.cancelar();
      this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
        this.router.navigate(["/pages/adicionar-credito"]));
      this.spinner.hide('default');
    }, 1500);
  }

  cancelar() {
    this.dialogRef.close();
  }

  // convenience getter for easy access to form fields
  get f() { return this.creditoVoucherForm.controls; }

}
